import { Component, OnInit, Input, ElementRef, HostBinding } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { ImageModel } from '../../models/image/image.model';
import { ImageStylingModel } from '../../models/image/image-styling.model';
import { ImageTemplates } from '../../templates/image.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Image Component</p>
 * <pre>
 * <code>
 * import {{'{'}} ImageModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} ImageStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-image<code>></code><code><</code><code>/</code>cf-image<code>></code>
 * </code>
 * </pre>
 */
export class CfImageComponent extends CfCoreComponent implements OnInit {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * <pre>{{'{'}}
 *  display: boolean,      // Default: frue.
 *  disable: boolean,      // Default: false.
 *  label: string,         // Empty string by default.
 *  labelPosition: string, // Default: bottom.
 *  url: string            // Default: 'https: ....jpg'
 * {{'}'}}
 * </pre>
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 *  display: true,
 *  label: 'Siberian Husky'
 *  labelPosition: 'left',
 *  url: 'https://github.com/Cedrusco/cedrus-fusion-lite/blob/master/src/demo/src/assets/images/siberian-husky.jpg?raw=true'
 * {{'}'}}
 * </pre>
 */
public properties: ImageModel;
/**
 * <p> dynamicClass: function() -> string,	// Function that returns name of the class </p>
 * <p> class: string												// Name of the css class selector </p>
 * <p> themeColor: string										// primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 * 	// Container surrounding the Image
 * 	container:{{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}},
 * 	// image styling
 * 	image:{{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}},
 * 	// label styling
 * 	label:{{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}}
 * {{'}'}}
 * </pre>
 */
public styling: ImageStylingModel;
/**
 * <p> The label of the image</p>
 * @param {?} value
 * @return {?}
 */
set label(value: string) { this.properties.label = value; }
/**
 * <p> The label position of the image. Can be: top, bottom, right, left</p>
 * @param {?} value
 * @return {?}
 */
set labelPosition(value: string) { this.properties.labelPosition = value; }
/**
 * <p> The url of the iamge.</p>
 * @param {?} value
 * @return {?}
 */
set url(value: string) { this.properties.url = value; }
/**
 * @hidden 
 * It is function for creating Notification click events by using Core Component <b>notificationAction</b> event emmiter.
 * @param {?} notification 	it is json notification object
 * @return {?}
 */
cfNotificationAction(notification) { this.notificationAction.emit(notification); }
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new ImageModel();
    this.styling = new ImageStylingModel();
  }
/**
 * @hidden 
 * <p> Initialize the proerties and styling object with the appropriate values.</p>
 * @return {?}
 */
ngOnInit(): void {
    if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
    this.getMyTemplate('image', ImageTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'IMAGE').then( sampler => {
        // console.log('IMAGE', this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-image',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-image-base'\"> <div class=\"cf-image-container {{properties?.labelPosition}}\"> <div style=\"display: flex; flex-grow: 1; padding: 8px;\" [class]=\"styling?.label?.class\" [ngClass]=\"getDynamicClasses(styling?.label?.dynamicClass)\" *ngIf=\"properties?.label !== '' && (properties?.labelPosition === 'top' || properties?.labelPosition === 'left')\">{{properties?.label}}</div> <img class=\"{{activeTemplate.style?.image?.class}} {{styling?.image?.class}} {{getDynamicClasses(activeTemplate.style?.image?.dynamicClass)}} {{getDynamicClasses(styling?.image?.dynamicClass)}}\" [ngClass]=\"'cf-image'\" src=\"{{properties.url}}\" alt=\"CF Image: {{properties?.label}}\"> <div style=\"display: flex; flex-grow: 1; padding: 8px;\" [class]=\"styling?.label?.class\" [ngClass]=\"getDynamicClasses(styling?.label?.dynamicClass)\" *ngIf=\"properties?.label !== '' && (properties?.labelPosition === 'right' || properties?.labelPosition === 'bottom')\">{{properties?.label}}</div> </div> <cf-notification *ngIf=\"notification && (notification?.value || notification?.icon)\" [settings]=\"notification\" (click)=\"cfNotificationAction(notification)\"></cf-notification> </div>",
  styles: [":host { position: relative; z-index: 0; display: flex; max-width: 100%; max-height: 100%; } :host .cf-image-container { width: 100%; height: 100%; } :host .cf-image-container .cf-image-label { display: flex; flex-grow: 1; padding: 8px; } :host .cf-image-container .cf-image { display: flex; box-sizing: border-box; } :host .cf-image-container.right { display: flex; flex-direction: row; } :host .cf-image-container.left { display: flex; flex-direction: row; } :host.notification-clickable cf-notification:hover { cursor: pointer; } .cf-defaultImage { max-height: 80%; max-width: 80%; } .cf-defaultImageContainer { height: auto; width: auto; font-size: 12px; font-family: \"Avenir\", \"Helvetica\", sans-serif; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'label': [{ type: Input, args: ['label', ] },],
'labelPosition': [{ type: Input, args: ['labelPosition', ] },],
'url': [{ type: Input, args: ['url', ] },],
};
}

function CfImageComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfImageComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfImageComponent.ctorParameters;
/** @type {?} */
CfImageComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfImageComponent.prototype.notificationClickable;
/**
 * <pre>{{'{'}}
 *  display: boolean,      // Default: frue.
 *  disable: boolean,      // Default: false.
 *  label: string,         // Empty string by default.
 *  labelPosition: string, // Default: bottom.
 *  url: string            // Default: 'https: ....jpg'
 * {{'}'}}
 * </pre>
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 *  display: true,
 *  label: 'Siberian Husky'
 *  labelPosition: 'left',
 *  url: 'https://github.com/Cedrusco/cedrus-fusion-lite/blob/master/src/demo/src/assets/images/siberian-husky.jpg?raw=true'
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfImageComponent.prototype.properties;
/**
 * <p> dynamicClass: function() -> string,	// Function that returns name of the class </p>
 * <p> class: string												// Name of the css class selector </p>
 * <p> themeColor: string										// primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 * 	// Container surrounding the Image
 * 	container:{{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}},
 * 	// image styling
 * 	image:{{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}},
 * 	// label styling
 * 	label:{{'{'}}
 * 		dynamicClass,
 * 		class
 * 	{{'}'}}
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfImageComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfImageComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
